var _defs, _path, _rect, _g, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4583in",
    height: "1.4583in",
    viewBox: "0 0 37.042 37.042",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 7,
    gradientTransform: "matrix(0 0 0 0 -192.32 38.642)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3a995",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1329",
    x1: 54.811,
    x2: 91.853,
    y1: 32.815,
    y2: 32.815,
    gradientTransform: "translate(100.95 132.05)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4-62",
    x1: 41.092,
    x2: 59.259,
    y1: 94.596,
    y2: 94.596,
    gradientTransform: "matrix(1.3369 0 0 .74799 107.2 99.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7e7867",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8-7",
    x1: 64.6,
    x2: 65.922,
    y1: 76.485,
    y2: 76.485,
    gradientTransform: "translate(107.2 99.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c9c2b5",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2988",
    x1: 35.503,
    x2: 40.848,
    y1: 123.66,
    y2: 123.66,
    gradientTransform: "matrix(1.7572 0 0 .5691 107.2 99.04)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#7"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-155.76 -146.34)",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215.9,
    height: 279.4,
    fill: "#fcfcfc",
    style: {
      paintOrder: "markers fill stroke"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-155.76 -146.34)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 155.76,
    y: 146.34,
    width: 37.042,
    height: 37.042,
    ry: 2.0045,
    fill: "url(#linearGradient1329)",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.75,
    y: 151.26,
    width: 17.067,
    height: 19.419,
    ry: 8.5334,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m185.2 165.87a14.252 14.252 0 0 1-10.918 5.091 14.252 14.252 0 0 1-10.918-5.091l10.918-9.161z",
    fill: "#413e35",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.94374
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 155.76 146.34)",
    d: "m70 23.994c0.44952 0 0.89583 0.011939 1.3398 0.033203-0.4442-0.021134-0.89023-0.033203-1.3398-0.033203zm0 0c-0.39112 0-0.77897 0.011328-1.166 0.027343 0.38707-0.016019 0.77487-0.027343 1.166-0.027343zm-1.418 0.037109c-0.36979 0.018624-0.7378 0.045156-1.1035 0.078125 0.36568-0.032972 0.73374-0.059497 1.1035-0.078125zm3.0195 0.011719c0.4246 0.024344 0.84659 0.056271 1.2656 0.099609-0.41885-0.043034-0.84129-0.075442-1.2656-0.099609zm-4.3301 0.085937c-0.37431 0.036563-0.74556 0.081506-1.1152 0.13281 0.36968-0.051319 0.74091-0.096241 1.1152-0.13281zm5.6816 0.023438c0.45646 0.048656 0.91005 0.10709 1.3594 0.17773-0.44945-0.070247-0.90284-0.12939-1.3594-0.17773zm1.3594 0.17773c2.3403 0.36795 4.5808 1.0298 6.6836 1.9453a25.322 29.249 0 0 1 0-0.003907c0.071422 0.031044 0.14179 0.064074 0.21289 0.095704 0.11626 0.051715 0.23227 0.10298 0.34766 0.15625 0.020819 0.009621 0.041709 0.019624 0.0625 0.029296 0.054221 0.0252 0.10808 0.050631 0.16211 0.076172 0.021636 0.010239 0.042849 0.020957 0.064453 0.03125 0.094868 0.045201 0.18894 0.090471 0.2832 0.13672 0.013572 0.006652 0.027457 0.012858 0.041016 0.019531 0.085015 0.041887 0.16939 0.08422 0.25391 0.12695 0.043632 0.022041 0.087363 0.044141 0.13086 0.066407 0.089264 0.045737 0.17888 0.091994 0.26758 0.13867 0.13173 0.069274 0.26214 0.1396 0.39258 0.21094 0.13076 0.071513 0.26118 0.14518 0.39062 0.21875 0.12969 0.073703 0.25837 0.14692 0.38672 0.22266 4.7496 2.8028 8.5753 6.9924 10.924 12.021-3.7918-8.1224-11.432-14.059-20.604-15.492zm-8.332-0.044922c-0.3644 0.052957-0.72641 0.11463-1.0859 0.18164 0.35934-0.06698 0.72173-0.1287 1.0859-0.18164zm-1.3047 0.22266c-0.34262 0.066737-0.68362 0.13949-1.0215 0.21875 0.33848-0.079433 0.67823-0.15189 1.0215-0.21875zm-1.3047 0.28711c-0.33714 0.082878-0.67186 0.17245-1.0039 0.26758 0.33157-0.09501 0.66724-0.18478 1.0039-0.26758zm-1.2168 0.33008c-0.33215 0.098089-0.66353 0.20043-0.99024 0.31055 0.32714-0.1103 0.65763-0.21231 0.99024-0.31055zm-1.2559 0.4043c-0.30247 0.10545-0.6029 0.2145-0.90039 0.33008 0.29742-0.11559 0.59798-0.22462 0.90039-0.33008zm-1.1152 0.41406c-0.35331 0.14072-0.70299 0.28862-1.0488 0.44336 0.34591-0.15482 0.69543-0.30257 1.0488-0.44336zm-1.0566 0.44531c-0.35001 0.15673-0.69513 0.32145-1.0371 0.49219 0.34204-0.17082 0.68704-0.33538 1.0371-0.49219zm-1.1895 0.57031c-0.33985 0.17235-0.67636 0.35124-1.0078 0.53711 0.33152-0.18597 0.66788-0.36467 1.0078-0.53711zm-1.0664 0.57031c-0.31546 0.17792-0.6261 0.36287-0.93359 0.55273 0.30717-0.18972 0.61847-0.37494 0.93359-0.55273zm-1.1406 0.68164c-0.30438 0.19171-0.60428 0.38862-0.90039 0.5918 0.29617-0.20329 0.59594-0.39999 0.90039-0.5918zm-0.98828 0.65234c-0.31088 0.21511-0.6186 0.43662-0.91992 0.66406 0.30147-0.22763 0.60888-0.44878 0.91992-0.66406zm-1.0234 0.74414c-0.2903 0.2213-0.57642 0.44722-0.85742 0.67969 0.28083-0.23241 0.56729-0.45844 0.85742-0.67969zm-1.0117 0.80859c-0.27401 0.23008-0.54391 0.46265-0.80859 0.70312 0.26426-0.24014 0.53504-0.47334 0.80859-0.70312zm30.07 0.71289a39.264 29.249 0 0 1-36.078 17.727 39.264 29.249 0 0 1-3.6504-0.12695c0.042946-0.43518 0.095366-0.86802 0.1582-1.2969-0.19381 1.3223-0.29688 2.675-0.29688 4.0527v7.5781c0 15.229 12.261 27.49 27.49 27.49s27.49-12.261 27.49-27.49v-7.5781c0-1.4729-0.11693-2.9172-0.33789-4.3262a25.322 29.249 0 0 1-14.775-16.029zm14.775 16.029c-0.080744-0.51487-0.17449-1.0245-0.2832-1.5293 0.10862 0.50435 0.20252 1.0149 0.2832 1.5293zm-54.346 0.27344c0.18851-1.2866 0.46513-2.5425 0.82422-3.7637-0.35921 1.2212-0.63564 2.4771-0.82422 3.7637zm0.82422-3.7637c0.1197-0.40707 0.24901-0.81012 0.38672-1.209-0.13773 0.3988-0.267 0.80198-0.38672 1.209zm0.38672-1.209c0.27542-0.79774 0.58697-1.5797 0.93164-2.3418-0.345 0.76252-0.65598 1.5436-0.93164 2.3418zm0.93164-2.3418c0.34069-0.75332 0.71444-1.4883 1.1191-2.2031-0.40484 0.71481-0.77832 1.4499-1.1191 2.2031zm6.5059-8.959c-0.28674 0.26162-0.56644 0.53123-0.8418 0.80469 0.27552-0.2737 0.55488-0.54284 0.8418-0.80469zm-0.91016 0.87109c-0.27898 0.27898-0.55159 0.56469-0.81836 0.85547 0.26691-0.29104 0.53922-0.57624 0.81836-0.85547zm-0.81836 0.85547c-0.27903 0.30414-0.55119 0.61506-0.81641 0.93164 0.26495-0.31637 0.53767-0.6277 0.81641-0.93164zm-0.81641 0.93164c-0.26501 0.31634-0.52269 0.6385-0.77344 0.9668 0.25068-0.32832 0.50849-0.65043 0.77344-0.9668zm-0.77344 0.9668c-0.24937 0.32649-0.49176 0.65824-0.72656 0.99609 0.2347-0.33782 0.4773-0.66964 0.72656-0.99609zm-0.73633 1.0098c-0.22952 0.3307-0.45088 0.66668-0.66602 1.0078 0.21507-0.34114 0.43656-0.67711 0.66602-1.0078zm-0.69531 1.0547c-0.21185 0.33743-0.41786 0.68017-0.61523 1.0273 0.19749-0.34754 0.40324-0.68957 0.61523-1.0273zm48.217 2.9883c0.21212 0.45486 0.41205 0.9166 0.59961 1.3848-0.18759-0.46842-0.38744-0.92965-0.59961-1.3848zm0.59961 1.3848c0.37729 0.94174 0.7036 1.9098 0.97656 2.9004-0.27286-0.99036-0.59948-1.9588-0.97656-2.9004zm0.97656 2.9004c0.13594 0.49334 0.25836 0.99186 0.36719 1.4961-0.10884-0.50427-0.23125-1.0027-0.36719-1.4961z",
    fill: "#968c77",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.31 169.8a12.143 12.143 0 0 0-6.0999 1.6268 12.143 12.143 0 0 0-6.0715 10.517v1.4449h24.287v-1.4449a12.143 12.143 0 0 0-6.0715-10.517 12.143 12.143 0 0 0-6.0441-1.6268z",
    fill: "url(#4-62)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 169.59,
    y: 169.42,
    width: 9.3929,
    height: 3.0421,
    fill: "url(#linearGradient2988)",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m174.31 169.8c-1.7676-4e-3 -3.5149 0.37804-5.1196 1.1193l1.6533 2.9802h7.528v-3.39c-1.3036-0.46632-2.6773-0.70628-4.0618-0.70952z",
    fill: "#968c77",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.58,
    y: 165.13,
    width: 5.409,
    height: 7.7654,
    ry: 2.7045,
    fill: "#968c77",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.75,
    cy: 161.52,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.75,
    cy: 161.52,
    rx: 0.885,
    ry: 1.2626,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.82,
    cy: 161.52,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#413e35"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.82,
    cy: 161.52,
    rx: 0.885,
    ry: 1.2626,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m163.37 165.87 2.8018-8.7026 1.1575 10.44z",
    stopColor: "#000000",
    strokeWidth: 0.94374
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.2 165.87-2.8018-8.7026-1.1575 10.44z",
    stopColor: "#000000",
    strokeWidth: 0.94374
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.28 152.69c-3.7832 0-6.8732 2.8598-7.2368 6.5443a10.388 7.7387 0 0 0 0.96584 0.0336 10.388 7.7387 0 0 0 9.973-5.5707c-1.0834-0.63941-2.348-1.0072-3.7021-1.0072z",
    stopColor: "#000000",
    strokeWidth: 1.0223
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.19 153.29a6.6998 7.7387 0 0 0 4.2747 5.5263c-0.39066-2.4909-2.0367-4.5535-4.2747-5.5263z",
    stopColor: "#000000",
    strokeWidth: 0.821
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m178.98 169.42a3.2348 3.2348 0 0 1 0.75335 3.1458 3.2348 3.2348 0 0 1-2.3477 2.2253 3.2348 3.2348 0 0 1-3.101-0.92048l2.3477-2.2253z",
    fill: "#d3cdc3",
    stopColor: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m169.59 169.42a3.2348 3.2348 0 0 0-0.75335 3.1458 3.2348 3.2348 0 0 0 2.3477 2.2253 3.2348 3.2348 0 0 0 3.101-0.92048l-2.3477-2.2253z",
    fill: "#d3cdc3",
    stopColor: "#000000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 172.46,
    cy: 176.19,
    r: 0.66133,
    fill: "url(#8-7)",
    stopColor: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait7);
export default __webpack_public_path__ + "static/media/player-portrait-7.89dd512db476726b0bdeb0fdf284a960.svg";
export { ForwardRef as ReactComponent };